<section class="flex w-full items-center gap-3 overflow-visible!">
  <label
    class="input input-bordered focus-within:input-primary rounded-lg w-full max-w-md overflow-visible! m-1 focus-within:ring-2 focus-within:ring-primary focus-within:ring-offset-2 focus-within:relative focus-within:z-10">
    <span class="icon-[mdi--magnify] text-base-content/40"></span>
    <input lepiInput [(value)]="query" [debounce]="300" type="text" placeholder="검색어를 입력해주세요." required />
  </label>
  <div class="flex-1"></div>
  <div class="flex items-center gap-2 shrink-0">
    <ng-content name="[buttons]" />
    @if (!hideExcelButton()) {
      <button (click)="exportExcel()" class="btn btn-ghost btn-square">
        <img class="size-6" src="https://api.iconify.design/vscode-icons:file-type-excel2.svg" alt="엑셀" />
      </button>
    }
  </div>
</section>
